module.exports = __webpack_public_path__ + "img/logo_coe.f36e85ae.png";